<template>
	<div class="qr-scanner-wrapper">
		<full-screen-modal-header title="Scan QR Code" @close="closeModal" />
		<div>
			<div :class="{ hide: isLoading }" class="video-wrapper" v-if="!error">
				<div id="reader" ref="qrcode"></div>
			</div>
			<div class="camera-error" v-if="error">{{ error }}</div>
			<loader v-if="isLoading && !error" class="qr-scanner-loader"></loader>
		</div>
	</div>
</template>

<script>
import { mapActions } from 'vuex'
import { Html5Qrcode } from '@/scripts/html5-qrcode/html5-qrcode'
import Loader from '../Loaders/Loader.vue'
import FullScreenModalHeader from './FullScreenModalHeader'

export default {
	components: {
		Loader,
		FullScreenModalHeader
	},

	data() {
		return {
			scanner: null,
			isLoading: false,
			isDetected: false,
			error: false
		}
	},

	mounted() {
		this.createQrcodeScanner()
	},

	methods: {
		...mapActions('venue', ['getQrInfo']),
		...mapActions('ui', ['addMainError']),

		async closeModal() {
			this.$emit('close')

			window.setTimeout(() => {
				if (this.scanner) {
					this.scanner.stop()
				}
			}, 300)
		},

		async createQrcodeScanner() {
			this.scanner = new Html5Qrcode('reader')
			const width = this.$el.clientWidth
			const height = this.$el.clientHeight
			const qrbox = width > height ? width / 2 : height / 2

			const config = { fps: 10, qrbox }

			try {
				this.isLoading = true
				this.error = false
				let prevMessage = ''
				const scanner = this.scanner.start(
					{ facingMode: 'environment' },
					config,
					async message => {
						if (prevMessage.length && prevMessage !== message) {
							this.scanner._resetError()
						}
						this.isDetected = true
						this.scanner._shouldScan = true

						try {
							const { subDomain, venueChainId } = this.$route.params
							const parsedUrl = new URL(message)
							const { pathname } = parsedUrl
							const qrCodeChunks = pathname.split('/')
							const qrCodeSubDomain = qrCodeChunks[1]
							const qrCodeVenueChainId = qrCodeChunks[2]
							const qrCodeId = qrCodeChunks[4]

							if (
								subDomain !== qrCodeSubDomain ||
								venueChainId !== qrCodeVenueChainId ||
								!qrCodeId
							) {
								this.scanner._setError()
							} else {
								this.scanner._setSuccess()
								this.scanner._shouldScan = false
								const resp = await this.getQrInfo(qrCodeId)

								this.$emit('qr-code-scanned', {
									location: resp.tableName,
									tableId: resp.tableId
								})
								window.setTimeout(() => {
									this.scanner.stop()
								}, 300)
							}

							prevMessage = message
						} catch (e) {
							this.scanner._setError()
						}
					},
					() => {}
				)
				await scanner
				this.isLoading = false
			} catch (err) {
				this.isLoading = false
				this.scanner = null
				if (err.includes('NotAllowedError')) {
					this.error = 'Camera permission denied'
				} else {
					this.error = err
				}
			}
		}
	}
}
</script>

<style scoped lang="scss">
.hide {
	opacity: 0;
}

.qr-scanner-loader {
	height: calc(100% - 48px);
	top: 48px;
}

.detected {
	font-size: 24px;
	color: #4ac692;
}
.qr-scanner-wrapper {
	position: absolute;
	z-index: 11;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	background: #2c2a35;
	display: table;
	height: 100%;
	width: 100%;
	overflow: hidden;
}
.scan-title {
	color: #fff;
	font-size: 20px;
	font-weight: 700;
	text-align: center;
}
.video-wrapper {
	margin: auto;
	position: absolute;
	z-index: 0;
	top: 48px;
	bottom: 0;
	left: 0;
	right: 0;
}
#reader {
	height: 100%;
}
video {
	width: 100%;
}
.camera-error {
	padding: 60px;
	text-align: center;
	font-size: 28px;
	font-weight: 700;
}
</style>
